import { render, staticRenderFns } from "./InstitutionsCreateEdit.vue?vue&type=template&id=564bd03c&scoped=true"
import script from "./InstitutionsCreateEdit.vue?vue&type=script&lang=js"
export * from "./InstitutionsCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./InstitutionsCreateEdit.vue?vue&type=style&index=0&id=564bd03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564bd03c",
  null
  
)

export default component.exports